import { LinkTab, NotFound } from "@dgs/core";
import { FC } from "react";
import { Navigate, Route, Routes } from "react-router";
import styled from "styled-components";
import { ArchivedCompanyClippingList } from "../clippings/details/ArchivedCompanyClippingList";
import { CompanyClippingList } from "../clippings/details/CompanyClippingList";
import { DefaultContentLayout, ViewPageContentLayout } from "../shared/Layout";
import { AccessDeniedPage } from "../shared/ui/AccessDeniedPage";
import { useGlobalTenants } from "../tenants/global/GlobalTenantProvider";
import { ArchivedCompanyList } from "./ArchivedCompanyList";
import { CompanyContactList } from "./CompanyContactList";
import { CompanyDetailsNavigation } from "./CompanyDetailsNavigation";
import { CompanyList } from "./CompanyList";
import { RedirectToCompany } from "./RedirectToCompany";
import { ArchivedCompanyViewPage } from "./view/ArchivedCompanyViewPage";
import { CompanyViewPage } from "./view/CompanyViewPage";

export const StyledLinkTab = styled(LinkTab)`
	background-color: #fff;
`;

export const CompanyPage: FC = () => {
	const { selected } = useGlobalTenants();

	if (!selected.tenant) {
		return <AccessDeniedPage />;
	}

	return (
		<Routes>
			<Route index element={<Navigate replace to="./active" />} />
			<Route path="active">
				<Route
					index
					element={
						<DefaultContentLayout>
							<CompanyList />
						</DefaultContentLayout>
					}
				/>
				<Route path=":id" element={<CompanyDetailsNavigation />}>
					<Route index element={<Navigate to="details" replace />} />
					<Route
						path="details"
						element={
							<ViewPageContentLayout>
								<CompanyViewPage />
							</ViewPageContentLayout>
						}
					/>
					<Route
						path="contacts"
						element={
							<DefaultContentLayout>
								<CompanyContactList />
							</DefaultContentLayout>
						}
					/>
					<Route
						path="clippings"
						element={
							<DefaultContentLayout>
								<CompanyClippingList />
							</DefaultContentLayout>
						}
					/>
				</Route>
			</Route>
			<Route path="archived">
				<Route
					index
					element={
						<DefaultContentLayout>
							<ArchivedCompanyList />
						</DefaultContentLayout>
					}
				/>
				<Route path=":id" element={<CompanyDetailsNavigation />}>
					<Route index element={<Navigate to="details" replace />} />
					<Route
						path="details"
						element={
							<ViewPageContentLayout>
								<ArchivedCompanyViewPage />
							</ViewPageContentLayout>
						}
					/>
					<Route
						path="contacts"
						element={
							<DefaultContentLayout>
								<CompanyContactList />
							</DefaultContentLayout>
						}
					/>
					<Route
						path="clippings"
						element={
							<DefaultContentLayout>
								<ArchivedCompanyClippingList />
							</DefaultContentLayout>
						}
					/>
				</Route>
			</Route>
			<Route path=":id" element={<RedirectToCompany />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
